<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="12" sm="10" md="8" lg="6" class="text-center">
                <payment-check></payment-check>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PaymentCheck from './components/PaymentCheck.vue'

export default {
    components: {
        PaymentCheck,
    }
}
</script>
